/*
    Add By POOM : 2024-05-20
*/
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import {
  Class_ETC_Decrypt,
  Class_ETC_SessionTimeOut,
} from "../Class/Class_Etc";
import Pathurl from "../Class/Pathurl.json";
import { Link } from "react-router-dom";
import { CP_CheckPermission } from "../Class/Class_Permission";

import CVOverview from "../PartialView/CV_Overview.js";

function M_customer_view() {
  //#region __ declare variable __

  const location = useLocation();
  const [pgFromPage, setPgFromPage] = useState("");
  const [pgCusid, setPgCusid] = useState(-1);
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isFirst, setIsFirst] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [CustomerName, setCustomerName] = useState("");

  const [showOrgTab, setshowOrgTab] = useState(false);

  //#endregion

  //#region __ UseEffect __
  useEffect(() => {
    if (isFirst === true) {
      let ckpermission = CP_CheckPermission(
        "master",
        ["customers_view"],
        false,
        true
      );
      if (ckpermission === true) {
        GetParameter(function () {
          GetConfig();
          if (isLoadedConfigData === true) {
            BindCustomer(function () {
              setIsLoadProgress(false);
              setIsFirst(false);
            });
          }
        });
      }
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData]);

  //#endregion

  //#region __ Function __

  function GetParameter(_callback) {
    let isNullParameter = false;
    let cusid = "";
    let fromPage = "";

    try {
      if (location.state === null) {
        isNullParameter = true;
      } else {
        cusid = Class_ETC_Decrypt(location.state?.cusid.toString());
        fromPage = Class_ETC_Decrypt(location.state?.fromPage.toString());

        if (cusid === "") {
          isNullParameter = true;
        }
      }
    } catch {
      isNullParameter = true;
    }

    if (isNullParameter) {
      window.location.replace("../" + Pathurl.m_customer);
      if (_callback != null) {
        _callback();
      }
    } else {
      setPgCusid(cusid);
      setPgFromPage(fromPage);

      if (_callback != null) {
        _callback();
      }
    }
  }

  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  async function BindCustomer(_callback) {
    let token = localStorage.getItem("TStoken");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      cus_id: pgCusid,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    await fetch(configData.API_URL + "Customer_Getdata", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status_ID === 2) {
          Class_ETC_SessionTimeOut();
        } else {
          if (result.total_Data > 0) {
            setCustomerName(result.cus_name);
            if (_callback != null) {
              _callback();
            }
          } else {
            window.location.replace("../" + Pathurl.m_customer);
          }
        }
      })
      .catch((error) => {
        window.location.replace("../" + Pathurl.m_customer);
      });
  }

  //#endregion

  //#region __ Event __

  const toggleFlagOrg = () => {
    setshowOrgTab(true);
  };

  //#endregion

  return (
    <>
      <Helmet>
        <title>Customer view</title>
      </Helmet>
      {/* Content Wrapper. Contains page content */}
      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-11 col-sm-12 col-12">
                <div>
                  <div className="text-center">
                    {" "}
                    <h1> {CustomerName}</h1>
                  </div>
                </div>
              </div>
              <div className="col-lg-1 col-sm-12 col-12 mb-1">
                <div className="search-icon float-right ">
                  <Link
                    to={"../" + pgFromPage}
                    className="btn btn-tool"
                    data-toggle="tooltip"
                    title="BACK TO Customer LIST"
                  >
                    <i className="fas fa-arrow-left" /> BACK
                  </Link>
                </div>
              </div>
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                {/* SELECT2 EXAMPLE */}
                <div className="">
                  <div className="card-body p-1 mt-1">
                    <div className="row ">
                      <div className="col-lg-2 col-sm-12 col-12  pl-0 pr-2 m-0">
                        <div className="mt-0"></div>

                        {/* Start Navigation */}
                        <div
                          className="nav flex-column nav-tabs bg-light card card-primary "
                          id="vert-tabs-tab"
                          role="tablist"
                          aria-orientation="vertical"
                        >
                          <a
                            className="nav-link  active"
                            id="vert-tabs-overview-tab"
                            data-toggle="pill"
                            href="#vert-tabs-overview"
                            role="tab"
                            aria-controls="vert-tabs-overview"
                            // aria-selected="true"
                          >
                            <div>
                              <span className="">
                                <i className="fas fa-tachometer-alt"> </i>{" "}
                                Overview
                              </span>
                            </div>
                          </a>
                          <a
                            className="nav-link "
                            id="vert-tabs-org-tab"
                            data-toggle="pill"
                            href="#vert-tabs-org"
                            role="tab"
                            aria-controls="vert-tabs-org"
                            aria-selected="false"
                            onClick={toggleFlagOrg}
                          >
                            <i
                              className="fas fa-circle fa-xs align-middle"
                              style={{ fontSize: "0.4rem" }}
                            />{" "}
                            Organization
                          </a>
                          <a
                            className="nav-link "
                            id="vert-tabs-department-tab"
                            data-toggle="pill"
                            href="#vert-tabs-department"
                            role="tab"
                            aria-controls="vert-tabs-department"
                            aria-selected="false"
                          >
                            <i
                              className="fas fa-circle fa-xs align-middle"
                              style={{ fontSize: "0.4rem" }}
                            />{" "}
                            Department
                          </a>
                          <a
                            className="nav-link "
                            id="vert-tabs-staff-tab"
                            data-toggle="pill"
                            href="#vert-tabs-staff"
                            role="tab"
                            aria-controls="vert-tabs-staff"
                            aria-selected="false"
                          >
                            <i
                              className="fas fa-circle fa-xs align-middle"
                              style={{ fontSize: "0.4rem" }}
                            />{" "}
                            Staffs
                          </a>
                          <a
                            className="nav-link "
                            id="vert-tabs-task-tab"
                            data-toggle="pill"
                            href="#vert-tabs-task"
                            role="tab"
                            aria-controls="vert-tabs-task"
                            aria-selected="false"
                          >
                            <i
                              className="fas fa-circle fa-xs align-middle"
                              style={{ fontSize: "0.4rem" }}
                            />{" "}
                            Task
                          </a>
                          <a
                            className="nav-link "
                            id="vert-tabs-cost-tab"
                            data-toggle="pill"
                            href="#vert-tabs-cost"
                            role="tab"
                            aria-controls="vert-tabs-cost"
                            aria-selected="false"
                          >
                            <i
                              className="fas fa-circle fa-xs align-middle"
                              style={{ fontSize: "0.4rem" }}
                            />{" "}
                            Position daily
                          </a>
                          <a
                            className="nav-link "
                            id="vert-tabs-tran-tab"
                            data-toggle="pill"
                            href="#vert-tabs-tran"
                            role="tab"
                            aria-controls="vert-tabs-tran"
                            aria-selected="false"
                          >
                            <i
                              className="fas fa-circle fa-xs align-middle"
                              style={{ fontSize: "0.4rem" }}
                            />{" "}
                            Transaction
                          </a>
                          <a
                            className="nav-link "
                            id="vert-tabs-TSperiod-tab"
                            data-toggle="pill"
                            href="#vert-tabs-TSperiod"
                            role="tab"
                            aria-controls="vert-tabs-TSperiod"
                            aria-selected="false"
                          >
                            <i
                              className="fas fa-circle fa-xs align-middle"
                              style={{ fontSize: "0.4rem" }}
                            />{" "}
                            Timesheet by period
                          </a>

                          <a
                            className="nav-link "
                            id="vert-tabs-TSbyStaff-tab"
                            data-toggle="pill"
                            href="#vert-tabs-TSbyStaff"
                            role="tab"
                            aria-controls="vert-tabs-TSbyStaff"
                            aria-selected="false"
                          >
                            <i
                              className="fas fa-circle fa-xs align-middle"
                              style={{ fontSize: "0.4rem" }}
                            />{" "}
                            Timesheet by Staff
                          </a>
                        </div>
                        {/* End Navigation */}
                      </div>

                      <div
                        className="col-lg-10 col-sm-12 col-12  p-0 m-0"
                        /*style={{ backgroundColor: "#FFF" }}*/
                      >
                        <div className="tab-content" id="vert-tabs-tabContent">
                          {/* Start OverView */}
                          <div
                            className="tab-pane text-left fade show active"
                            id="vert-tabs-overview"
                            role="tabpanel"
                            aria-labelledby="vert-tabs-overview-tab"
                          >
                            {isLoadedConfigData && (
                              <CVOverview
                                cusid={pgCusid}
                                API_URL={configData.API_URL}
                              />
                            )}
                          </div>
                          {/* End OverView */}

                          {/* Start Organization*/}
                          <div
                            className="tab-pane fade "
                            id="vert-tabs-org"
                            role="tabpanel"
                            aria-labelledby="vert-tabs-org-tab"
                          >
                            {showOrgTab && 
                            <></>
                            }
                          </div>
                          {/* End Organization*/}
                        </div>
                      </div>
                    </div>
                    {/* /.card-body */}
                  </div>
                  {/* /.card */}
                </div>
                {/* /.row (main row) */}
              </div>
              {/* /.container-fluid */}
            </div>
            {/* /.container-fluid */}
          </div>
        </section>
        {/* /.content */}
      </div>
      {/* /.content-wrapper */}
    </>
  );
}

export default M_customer_view;
